import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './modules/login/login.component';
import { AuthGuard } from './services/auth/auth.guard';
import { BrowserModule } from '@angular/platform-browser';
import { InicioComponent } from './inicio/inicio.component';
import { ControlVelocidadComponent } from './modules/flota/control-velocidad/control-velocidad.component';
import { PrivacyPolicyComponent } from './modules/privacy-policy/privacy-policy.component';
//import { AppComponent } from './app.component';
//-----


const routes: Routes = [
  { 
    path: '', 
    redirectTo: 'inicio', 
    pathMatch: 'full' 
  }, 
  {
    path: 'inicio',
    canActivate: [AuthGuard],
    component: InicioComponent,    
    data: {
      title: 'Inicio',
    },
    children: [        
      { 
        path: '', 
        redirectTo: 'flota', 
        pathMatch: 'full' 
      }, 
      {
        path: 'flota',
        loadChildren: './modules/flota/flota.module#FlotaModule',
        data: {
          title: 'Control de Flota',
        }
      }, 
      {
        path: 'movil',
        data: {
          title: 'Lista de Móviles'
        },
        loadChildren: './modules/movil/movil.module#MovilModule',
      },
      {
        path: 'admin',
        data: {
          title: 'Administración'
        },
        loadChildren: './modules/admin/admin.module#AdminModule',
      },
    ],    
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Acceso al Sistema'
    }
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
    data: {
      title: 'Politicas de Privacidad'
    }
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [BrowserModule, RouterModule.forRoot(routes)],
  exports: [RouterModule]  
})

export class AppRoutingModule { }
